/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


export class SelectableOptions {
  options: string[];
  selectedOptions: string[];
  query?: string;

  constructor() {
    this.options = [];
    this.selectedOptions = [];
  }

  getSelectedOptionsString?(delimiter: string = ", ") {
    return this.selectedOptions.join(delimiter);
  }
}
